import {checkReportDownload} from "@/api/analyze/analyze";
import {getDataInLocalStorage} from "@/utils/localStorageUtils";
import {fileDownload} from "@/utils/utils";
import axios from "axios";
import {Message} from "element-ui";
import log from "@/views/systemFunc/log/Log";
const baseURL = process.env.VUE_APP_BASE_API
export function showPublicLoading() {
  return this.$loading.service({
    spinner: 'el-icon-loading',
    text: '拼命加载中',
    background: 'rgba(0,0,0,.8)'
  })
}
// 通用下载方法
export function download(url, params,id,name) {
  let downProgress = {}
  let that = this
  var loading = this.$loading.service({
    spinner: 'el-icon-loading',
    text: '拼命加载中',
    background: 'rgba(0,0,0,.8)'
  })
  let uniSign = new Date().getTime() + '' // 可能会连续点击下载多个文件，这里用时间戳来区分每一次下载的文件
  return this.$http.post(url, params, {
    // transformRequest: [(params) => {
    //   return tansParams(params)
    // }],
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob',
    onDownloadProgress(progress) {
      loading.close()
      // progress对象中的loaded表示已经下载的数量，total表示总数量，这里计算出百分比
      downProgress = Math.round(100 * progress.loaded / progress.total)
      // 将此次下载的文件名和下载进度组成对象再用vuex状态管理
      that.$store.commit('downLoadProgress/SET_PROGRESS', { path: uniSign, 'progress': downProgress,'id':id,'name':name })
    }
  }).then((data) => {// 文件流传输完成后，开启文件下载
    console.log(data)
    const content = data.file
    let filename=""
    if(name){
      if(data.fileName.includes("resData")){
        filename=data.fileName.replace("resData",name)
        console.log(filename)
      }else {
        filename=name+".zip"
      }
    }else {
      filename = data.fileName
    }
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename || url.split('/')[url.split('/').length - 1]
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
    this.$messageUi.error('该文件无法下载')
  })
}
//下载分析报告
export function downReport(analyzeId){
   return new Promise((resolve, reject) =>{
     checkReportDownload(analyzeId).then(res=>{
    if (res.data){
      const url = `${baseURL}/preview/downloadReport/${analyzeId}?token=${getDataInLocalStorage("token")}`
      const elink = document.createElement('a')
      elink.href = url
      document.body.appendChild(elink)
      elink.click()
      document.body.removeChild(elink);
      resolve('ok')
    }else {
     resolve(res.message)
    }
  }).catch(err=>{
    reject(err)
  })
})
}
//下载，正确时返回blob,但错误时返回json数据
export function downAsBlob(method,url){
  return new Promise((resolve, reject) => {
   axios({
      method: method,
      url: url,
      responseType: 'blob',
    }).then(res=>{
      if(res.file){
        fileDownload(res.file, res.fileName)
       // resolve('下载成功')
        showMessage('success','下载成功')
      }else {
        axios({
          method: method,
          url: url,
        }).then(res1=>{
          // console.log(Message,res1)
          // reject('下载失败'+res1.message)
          showMessage('error','下载失败，'+res1.message)
        })
      }
    })
  })
}
function showMessage(type,msg){
  Message({
    type:type,
    message:msg,
  })
}
